import { Box, CssVarsProvider } from "@mui/joy";
import { LicenseInfo } from "@mui/x-data-grid-pro";
import { TourProvider } from "@reactour/tour";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import ConfettiCenter from "./context/confettiCenter/confettiCenter";
import { AppConfig } from "./environement";
import { theme } from "./hooks/config/themeConfig";
import NerdApp from "./hooks/nerdApp/nerdApp";
import "./i18n";
import "./index.css";
import { store } from "./redux/store";
import AskQuestion from "./hooks/askQuestion";

document.title = AppConfig.app.title || "Rhapsody";
const favIcon = document.getElementById("favicon");
if (favIcon !== null && favIcon instanceof HTMLLinkElement)
  favIcon.href = AppConfig.app.favicon || "";

Sentry.init({
  dsn: "https://cdf242cf4dc44566b6dc88237793a769@o1058683.ingest.sentry.io/6046515",
  integrations: [new Integrations.BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

//Mui X Pro License Key
LicenseInfo.setLicenseKey(
  "7908c976763f4c481913a58651a92565T1JERVI6MzkwMDIsRVhQSVJZPTE2Nzc5NTg1MjQwMDAsS0VZVkVSU0lPTj0x",
);

const container = document.getElementById("root");

const steps = [
  {
    selector: ".answer-checkboxes",
    content:
      "For each Projects, use the checkboxes to give your answer (Accept, Decline, Hold)",
  },
  {
    selector: ".view-details",
    content: "Click here to view each Project's details",
  },
  {
    selector: ".submit-button",
    content: "Click to here to submit your answers",
  },
];

if (container != null) {
  const root = createRoot(container);
  root.render(
    <TourProvider steps={steps}>
      <BrowserRouter>
        <Provider store={store}>
          <CssVarsProvider theme={theme}>
            <ConfettiCenter>
              <AskQuestion>
                <NerdApp />
              </AskQuestion>
            </ConfettiCenter>
          </CssVarsProvider>
        </Provider>
      </BrowserRouter>
    </TourProvider>,
  );
}
